import { Box, Flex } from '@chakra-ui/react';
import type { GachaDetail } from '~/types/resources/gachaDetail';
import { CollectionBenefitList } from './CollectionBenefitList';
import { CollectionPrizeList } from './CollectionPrizeList';

import { UndeliveredHistoryCard } from '~/components/pickup/UndeliveredHistoryCard';
import type { BenefitPrize } from '~/types/resources/benefitPrize';
import { GrantedItem } from '~/types/resources/grantedItem';
import type { OrderPrize } from '~/types/resources/orderPrize';
import type { OrderPrizeCategory } from '~/types/resources/orderPrizeCategory';
import { PrizeTicket } from '~/types/resources/prizeTicket';
import { RedeemTicket } from '~/types/resources/redeemTicket';

type Props = {
  gachaDetail: GachaDetail;
  orderPrizes: OrderPrize[];
  grantedItem: GrantedItem | null;
  prizeCategories: OrderPrizeCategory[];
  prizeOnOpen: () => void;
  setOrderPrize: (newOrderPrize: OrderPrize) => void;
  benefitOnOpen: () => void;
  setBenefitPrize: (newBenefitPrize: BenefitPrize) => void;
  prizeTickets: PrizeTicket[];
  redeemTicket: RedeemTicket[] | undefined;
};

export const CollectionDetail: React.FC<Props> = (props: Props) => {
  return (
    <Flex flexDir="column" w="full" bgColor="white">
      <Flex flexDir="column" bgColor="blank" w="full" p="16px" mb="16px">
        <Flex
          w="full"
          py="8px"
          display={props.redeemTicket == undefined ? 'none' : 'flex'}
        >
          <UndeliveredHistoryCard
            gachaID={props.gachaDetail.id}
            redeemTickets={props.redeemTicket}
          />
        </Flex>
        <CollectionPrizeList
          orderPrizes={props.orderPrizes}
          grantedPrizes={props.grantedItem?.prizes ?? []}
          prizeCategories={props.prizeCategories}
          onOpen={props.prizeOnOpen}
          setOrderPrize={props.setOrderPrize}
        />
        <CollectionBenefitList
          gachaDetail={props.gachaDetail}
          grantedBenefits={props.grantedItem?.benefits ?? []}
          benefitOnOpen={props.benefitOnOpen}
          setBenefitPrize={props.setBenefitPrize}
        />
        <Box h="80px" />
      </Flex>
    </Flex>
  );
};
